export function getNextAvailableAt(seconds = 60) {
  const nextAvailableAt = new Date();
  const delay = seconds;
  nextAvailableAt.setSeconds(nextAvailableAt.getSeconds() + delay);
  return nextAvailableAt;
}
